import { hasSuccessfulPaymentRecord } from "../payment/paymentCalculations";

export const getStoredFeeCollections = (registration) => ({
  additionalFees:
    registration?.additionalFees && Array.isArray(registration.additionalFees)
      ? registration.additionalFees
      : [],
  zeroPayments:
    registration?.zeroPayments && Array.isArray(registration.zeroPayments)
      ? registration.zeroPayments
      : [],
  payment:
    registration?.payment && Array.isArray(registration.payment)
      ? registration.payment
      : [],
});

export const getExistingRegistrationPaymentStatus = (registration) =>
  registration?.paid === true ||
  hasSuccessfulPaymentRecord(registration?.payment) ||
  registration?.confirmationDate !== null;

export const buildExistingRegistrationFormData = ({
  currentFormData,
  existingReg,
  isPaid,
}) => {
  const storedFees = getStoredFeeCollections(existingReg);

  return {
    ...currentFormData,
    email: existingReg.user.email,
    title: existingReg.user.title || "",
    firstName: existingReg.user.firstName || "",
    lastName: existingReg.user.lastName || "",
    mobile: existingReg.user.phone || "",
    gender: existingReg.user.gender || "",
    country: existingReg.user.country || "",
    state: existingReg.user.state || "",
    city: existingReg.user.city || "",
    address: existingReg.user.address || "",
    pincode: existingReg.user.zipCode || "",
    affiliation: existingReg.affiliation || "",
    institution: existingReg.institution || "",
    conference: existingReg.conference,
    category: existingReg.category || "",
    categoryId: existingReg.categoryId || null,
    registrationType: existingReg.registrationType || "",
    registrationTypeId: existingReg.registrationTypeId || null,
    membershipNumber: existingReg.membershipNumber || "",
    isaMembershipNumber: existingReg.isaMembershipNumber || "",
    department: existingReg.department || "",
    departmentId: existingReg.departmentId || null,
    otherDepartment: existingReg.otherDepartment || "",
    studentIdCard: existingReg.studentIdURL ? existingReg.studentIdURL : null,
    studentIdCardUploaded: existingReg.studentIdURL ? true : false,
    mciRegistered: existingReg.mciRegistered || "No",
    mciNumber: existingReg.mciNumber || "",
    specialRequirements: existingReg.specialRequirements || "",
    dietaryRestrictions:
      existingReg.additionalData?.dietaryRestrictions || "",
    specialization:
      existingReg.additionalData?.specialization ||
      existingReg.additionalData?.specilization ||
      "",
    designation: existingReg.additionalData?.designation || "",
    paid: isPaid,
    id: existingReg.registrationId,
    regId: existingReg.id,
    additionalFees: storedFees.additionalFees,
    zeroPayments: storedFees.zeroPayments,
    payment: storedFees.payment,
  };
};

export const getCategoryHistoryFromRegistration = (registration) => ({
  categoriesHistory: Array.isArray(
    registration?.additionalData?.categoriesHistory
  )
    ? registration.additionalData.categoriesHistory
    : [],
  registrationTypesHistory: Array.isArray(
    registration?.additionalData?.registrationTypesHistory
  )
    ? registration.additionalData.registrationTypesHistory
    : [],
});

export const buildKnownUserRegistrationSeed = ({
  currentFormData,
  anyRegistration,
  conferenceName,
}) => ({
  ...currentFormData,
  email: currentFormData.email || anyRegistration.user.email,
  firstName:
    currentFormData.firstName || anyRegistration.user.firstName || "",
  lastName: currentFormData.lastName || anyRegistration.user.lastName || "",
  mobile: currentFormData.mobile || anyRegistration.user.phone || "",
  country: currentFormData.country || anyRegistration.user.country || "",
  state: currentFormData.state || anyRegistration.user.state || "",
  city: currentFormData.city || anyRegistration.user.city || "",
  address: currentFormData.address || anyRegistration.user.address || "",
  pincode: currentFormData.pincode || anyRegistration.user.zipCode || "",
  affiliation:
    currentFormData.affiliation || anyRegistration.affiliation || "",
  institution:
    currentFormData.institution || anyRegistration.institution || "",
  id: null,
  regId: null,
  conference: conferenceName,
  category: "",
  categoryId: null,
  registrationType: "",
  registrationTypeId: null,
});

export const buildNewConferenceRegistrationSeed = ({
  currentFormData,
  conferenceName,
}) => ({
  ...currentFormData,
  id: null,
  regId: null,
  conference: conferenceName,
  category: "",
  categoryId: null,
  registrationType: "",
  registrationTypeId: null,
});
